import { InviteTeamButton } from '@/helpers/settingsHelper';
import SkeletonLoader from '@/pages/DatasetPage/SkeletonLoader/SkeletonLoader';
import { settingsSliceName, userDataSliceName } from '@/redux/constants';
import { getTeamDetails } from '@/redux/reducers/settingsSlice';
import clsx from 'clsx';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TeamGraphic from './../../../Components/UI/Graphics/team.svg';
import TeamMemberTable from './TeamMemberTable';

const TeamSettings = () => {
  const dispatch = useDispatch();
  const { teamName, teamMembers, isSettingsPageLoading } = useSelector(
    (state) => state[settingsSliceName]
  );
  const { isViewerAnalyst } = useSelector((state) => state[userDataSliceName]);

  useEffect(() => {
    dispatch(getTeamDetails());
  }, []);

  return (
    <div className='w-full px-16 pb-28'>
      {isSettingsPageLoading ? (
        <SkeletonLoader header={false} />
      ) : (
        <>
          <div className='flex items-start justify-start align-left'>
            <div className='w-full max-w-6xl'>
              <div className='flex flex-row justify-between w-full h-20 py-6 my-12 border-b border-shadow-200 min-w-[800px]'>
                <div className='text-xl font-extrabold text-ui-secondary text-[21px]'>Team</div>
                {!isViewerAnalyst ? <InviteTeamButton styles={{ color: 'sunrise' }} /> : null}
              </div>
            </div>
          </div>
          <div className={clsx('flex justify-center items-center align-middle')}>
            <div className='flex flex-col w-full'>
              {!teamMembers.length ? (
                <div className='flex flex-col items-center justify-center w-full'>
                  <div>
                    <img src={TeamGraphic} alt='team' className='w-[370px] h-[370px]' />
                  </div>

                  <div className='flex flex-col gap-3 mt-6 text-center'>
                    <div className='text-lg font-semibold'>Start Collaborating Today</div>
                    <div className='text-base'>
                      Big data is hard to share. Make your life easier and start collaborating
                      today.
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <div className='w-[800px] border bg-white flex flex-col gap-4 p-8'>
                    <div className='flex flex-row pb-4 mb-2 text-left border-b'>
                      <div className='flex flex-col justify-center w-1/2 gap-4 border-r h-28'>
                        <div className='text-lg font-extrabold'>Name</div>
                        <div>{teamName}</div>
                      </div>
                    </div>
                    <div>
                      <div className='text-lg font-extrabold'>Members</div>
                      <TeamMemberTable teamMembers={teamMembers} />
                      <div
                        className={clsx(
                          'flex flex-row justify-between w-full pt-2',
                          isViewerAnalyst && 'hidden'
                        )}
                      >
                        <InviteTeamButton
                          styles={{ color: 'midnight', iconName: 'plus-circle', variant: 'ghost' }}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default TeamSettings;
